// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___550d7b47f5d4ea18314","cls2":"News-cls2__dc5d1f382316515db0ed News-cls1___550d7b47f5d4ea18314"};